import PropTypes from 'prop-types';
import React from 'react';

const PriceTagIcon = ({ title = 'Lågt pris', titleId, ...props }) => (
	<svg
		aria-labelledby={titleId}
		fill="currentColor"
		height="1em"
		viewBox="0 -960 960 960"
		width="1em"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		{title ? <title id={titleId}>{title}</title> : null}
		<path d="M856-390 570-104q-12 12-27 18t-30 6q-15 0-30-6t-27-18L103-457q-11-11-17-25.5T80-513v-287q0-33 23.5-56.5T160-880h287q16 0 31 6.5t26 17.5l352 353q12 12 17.5 27t5.5 30q0 15-5.5 29.5T856-390ZM513-160l286-286-353-354H160v286l353 354ZM260-640q25 0 42.5-17.5T320-700q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640Zm220 160Z" />
	</svg>
);

PriceTagIcon.propTypes = {
	title: PropTypes.string,
	titleId: PropTypes.string,
};

export default PriceTagIcon;
